// extracted by mini-css-extract-plugin
export default {"blockTitle":"SideProperties_blockTitle__HxWHF","icon":"SideProperties_icon__plz+2","blockContentWithTooltip":"SideProperties_blockContentWithTooltip__TyKV6"};